/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicationControllerFindWebNewsById200ResponseData } from './publicationControllerFindWebNewsById200ResponseData';


export interface PublicationControllerFindWebNews200Response { 
    statusCode?: number;
    success?: boolean;
    data?: Array<PublicationControllerFindWebNewsById200ResponseData>;
    message?: string;
    error?: string;
}

